/*
 * QModel circle segments enumeration
 */
export enum CircleSegments {
  Segments16 = 0,
  Segments24 = 0x0004,
  Segments32 = 0x0008,
  Segments48 = 0x0010,
  Segments64 = 0x0020,
}
